var AJAX = {
  _updateSubelements: function (post, $input) {
    // build the val
    $input.parent().find('.input-group-addon').html('<img src="/includes/images/ajax-loader.gif" height="14" width="14" />');
    var postData = encodeURIComponent( $input.attr('name') )+'='+$input.val();
    var jqxhr = $.ajax({
      type: 'post',
      url: APPLICATION._PATH_PREFIX+'signup-accounts/'+$input.attr('data-name'),
      data: post+'&'+postData
    }).done(function(data){
      AJAX._subElementComplete(data, $input)
    });
  },
  _subElementComplete: function(data, $el){
    if(data.status) {
      $el.parents('.input-group').find('.input-group-addon').html('<i class="fa fa-check" aria-hidden="true"></i>');
    }
    else {
      $el.parents('.input-group').find('.input-group-addon').html('<i class="fa fa-times" aria-hidden="true"></i>');
    }
  }
};
// Export
module.exports =
  {

    // Reset password
    resetPassword:
    {
      _init: function()
      {
        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {
          // On generating the password
          $('#generate_password').click(function ()
          {
            // Generate the password
            PasswordGenerator.generate(function (password)
            {
              // Show the generated password
              $('#generated_password').val(password)

              // Enter the password
              $('#password').val(password)
            })
          })
        })
      }
    },

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {

        var query_string = 'search=' + $('#submissions').data('search')

        query_string += '&fibre_node_order=' + $('#submissions').data('fibre_node_order')

        query_string += '&signup_account_id=' + $('#submissions').data('signup_account_id')

        APPLICATION._APPLICATION.load(
          $('#submissions'),
          APPLICATION._PATH_PREFIX + 'signup-accounts/submissions?' + query_string,
          'SignupAccounts',
          'submissions'
        )
      }

    },

    submissions:
    {
      _init: function ()
      {
        
        var company_id = $('#company_id').val()

        var phase = $('#phase_id')
        
        
        APPLICATION._APPLICATION.processLinks('#submissions', 'SignupAccounts', 'submissions')
        // On click mail merge
        $('#mail-merge').not('.js-ignore').click(function ()
        {

          // The IDs
          var ids = []

          // Iterate over the checked IDs
          $('.js-signup_account_ids:checked').each(function ()
          {
            ids.push($(this).val())
          }
          )

          // If 1 or more
          if (ids.length > 0)
          {
            document.location.href = APPLICATION._PATH_PREFIX + 'signup-accounts/mail-merge?signup_account_ids=' + ids.join(',')
          }

        }
        ).addClass('js-ignore')

        $('.js-value').not('js-ignore').change(function ()
        {

          var id = $('.js-signup_account_ids', $(this).closest('tr')).val() 

          var data = {}

          if ($(this).is('[type="checkbox"]'))
          {
            data[$(this).attr('name')] = this.checked ? 1 : 0
          }

          else
          {
            data[$(this).attr('name')] = $(this).val()
          }

          $.post(APPLICATION._PATH_PREFIX + 'signup-accounts/update/' + id, data)

        }
        ).addClass('js-ignore')

        $('[data-type] > input[type="checkbox"]').not('.js-ignore').each(function(){
          var $this = $(this);

          $this.on('change', function(){
            var $this = $(this);
            var status = $this.prop('checked') ? 1 : 0;
            // Build the post data
            var $parent = $this.parents('[data-type]');
            var type = $parent.attr('data-type');

            var val = $parent.find('input[type="checkbox"]').attr('name');
            var post = $parent.find('input[type="hidden"]').serialize();

            post += '&' + encodeURIComponent(val)+'='+status;

            // perofrm ajax call to update the database
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'signup-accounts/'+type,
              data: post
            })
              .done(function(data){
                if(status == 1) {
                  if(data.status) {
                    // find any child elements and convert them into inputs
                    $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                      var $e = $(e);

                      var $input = $("<input>", {
                        val: $e.text(),
                        type: "text",
                        name: $e.attr('data-name')
                      });
                      $e.replaceWith($input);
                      $input.wrap('<div class="input-group" />');
                      $input.attr('data-name', $input.attr('name'));
                      $input.parent().append('<span class="input-group-addon" data-name="'+$e.attr('data-name')+'"></span>');
                      // Should be event based?
                      if($input.attr('name') == 'imei') {
                        $input.attr('size', 20);
                        $input.attr('maxlength', 15);
                      }
                      $input.attr('data-parent', val);
                      $input.on('blur', function(){
                        console.log('BLUR');
                        AJAX._updateSubelements(post, $input);
                      });

                    });
                  }
                }
                else {
                  // remove boxes
                  $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                    var $span = $("<span>", {
                      text: $(e).val()
                    });
                    $span.attr('data-name', $(e).attr('data-name'));
                    $span.attr('data-parent', $(e).attr('data-parent'));
                    $(e).parent().replaceWith($span);
                  });
                }
              });

          });

        }).addClass('js-ignore');


        // set the events on default boxes
        $('[data-parent]').each(function(i, e){
          var $input = $(e);
          $input.on('blur', function () {
            // build the val
            $input.parent().find('.input-group-addon').html('<img src="/includes/images/ajax-loader.gif" height="14" width="14" />');
            var $parent = $('input[name="'+$input.attr('data-parent')+'"]');
            var post = $parent.parents('form').serialize();
            var postData = encodeURIComponent( $input.attr('name') )+'='+$input.val();
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'signup-accounts/'+$input.attr('data-name'),
              data: post+'&'+postData
            }).done(function(data){
              $input.parent().find('.input-group-addon').html('');
              AJAX._subElementComplete(data, $input)
            });
          });
        });

        $('input[name=mifi_box_returned]').on('change',function() {
          
          //var attr = $(this).attr('checked');
          var attr = $(this).prop('checked');

          if(attr == false)
          //if (!$(this).checked)
          {
            
           

            //$(this).removeAttr('checked');
          } else
          {
            
            //$(this).prop("checked",true);
            box = $('.js-mifi-issued', $(this).closest('tr'));
            boxattr = box.prop('checked'); 
            //if (!box.checked)
            if (boxattr == false )
            {
              //update to reflect they WERE issued a box
              box.prop("checked", true).change();
              box.trigger('change');
             
            } else
            {
              //do nothing
              
              
            }
          }
        })
      }
    },
    voice:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#voiceservice'), APPLICATION._PATH_PREFIX + 'signup-accounts/voiceservice', 'SignupAccounts', 'voiceservice')
      }

    },
    voiceservice:
    {
      _init: function()
      {
        APPLICATION._APPLICATION.processLinks('#voiceservice', 'SignupAccounts', 'voiceservice')

        // @TODO - This code is repetitive. After merging with Mi-Fi branch
        // they should share this...
        $('.js-value').not('js-ignore').change(function ()
        {

          var id = $('.js-signup_account_ids', $(this).closest('tr')).val()

          var data = {}

          data[$(this).attr('name')] = $(this).val()

          $.post(APPLICATION._PATH_PREFIX + 'signup-accounts/update/' + id, data)

        }
        ).addClass('js-ignore')

        $('[data-type] > input[type="checkbox"]').not('js-ignore').each(function(){
          var $this = $(this);

          $this.on('change', function(){
            var $this = $(this);
            var status = $this.prop('checked') ? 1 : 0;
            // Build the post data
            var $parent = $this.parents('[data-type]');
            var type = $parent.attr('data-type');

            var val = $parent.find('input[type="checkbox"]').attr('name');
            var post = $parent.find('input[type="hidden"]').serialize();

            post += '&' + encodeURIComponent(val)+'='+status;

            // perofrm ajax call to update the database
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'signup-accounts/'+type,
              data: post
            })
              .done(function(data){
                if(status == 1) {
                  if(data.status) {
                    // find any child elements and convert them into inputs
                    $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                      var $e = $(e);

                      var $input = $("<input>", {
                        val: $e.text(),
                        type: "text",
                        name: $e.attr('data-name')
                      });
                      $e.replaceWith($input);
                      $input.wrap('<div class="input-group" />');
                      $input.attr('data-name', $input.attr('name'));
                      $input.parent().append('<span class="input-group-addon" data-name="'+$e.attr('data-name')+'"></span>');
                      // Should be event based?
                      if($input.attr('name') == 'imei') {
                        $input.attr('size', 20);
                        $input.attr('maxlength', 15);
                      }
                      $input.attr('data-parent', val);
                      $input.on('blur', function(){
                        console.log('BLUR');
                        AJAX._updateSubelements(post, $input);
                      });

                    });
                  }
                }
                else {
                  // remove boxes
                  $this.parents('tr').find('[data-parent="'+val+'"]').each(function(i, e){
                    var $span = $("<span>", {
                      text: $(e).val()
                    });
                    $span.attr('data-name', $(e).attr('data-name'));
                    $span.attr('data-parent', $(e).attr('data-parent'));
                    $(e).parent().replaceWith($span);
                  });
                }
              });

          });

        }).addClass('js-ignore');

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          var phase = $('#phase_id')

          APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'phase/dropdown-company/' + company_id + '?phase_id=' + phase.val(), 'Phase', 'allDropdown')

        }
        ).addClass('js-ignore').trigger('change')

        // set the events on default boxes
        $('[data-parent]').each(function(i, e){
          var $input = $(e);
          $input.on('blur', function () {
            // build the val
            $input.parent().find('.input-group-addon').html('<img src="/includes/images/ajax-loader.gif" height="14" width="14" />');
            var $parent = $('input[name="'+$input.attr('data-parent')+'"]');
            var post = $parent.parents('form').serialize();
            var postData = encodeURIComponent( $input.attr('name') )+'='+$input.val();
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'signup-accounts/'+$input.attr('data-name'),
              data: post+'&'+postData
            }).done(function(data){
              $input.parent().find('.input-group-addon').html('');
              AJAX._subElementComplete(data, $input)
            });
          });
        });
      }
    },
    sendReviewEmail: require('./SignupAccounts/sendReviewEmail'),
  }
